export default __webpack_public_path__ + "static/feature_03-1e4b7cfa8b29411517f6048aae6bf526.png";